import { useState } from 'react';
import { useCurrentUser } from '../../../../../hooks/useCurrentUser/useCurrentUser';
import { User, UserRoles } from '../../../../../types/models/user/user.types';
import ProfileLayout from '../../../../commons/ProfileLayout/ProfileLayout';
import Button from '../../../../designSystem/Button/Button';
import ProfileHeader from './../ProfileHeader/ProfileHeader';
import ProfileAccountForm from './ProfileAccountForm/ProfileAccountForm';
import ProfileAccountFormCOM from './ProfileAccountFormCOM/ProfileAccountFormCOM';
import DeleteAccountModal from './DeleteAccountModal/DeleteAccountModal';
import { ButtonColor } from '../../../../designSystem/Button/Button.types';

export default () => {
  const currentUser = useCurrentUser() as User;

  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

  return (
    <ProfileLayout>
      <ProfileHeader />
      <section className="profile__main-row">
        {currentUser?.role === UserRoles.Commercial ? (
          <ProfileAccountFormCOM />
        ) : (
          <ProfileAccountForm />
        )}
      </section>
      <div
        style={{
          marginTop: 'auto',
          padding: '0 var(--spacing-mToL)',
        }}>
        <Button
          style={{
            alignSelf: 'unset',
            textAlign: 'center',
            borderRadius: 6,
            width: '100%',
            paddingLeft: 0,
            paddingRight: 0,
          }}
          onClick={() => setDeleteModalOpen(true)}
          color={ButtonColor.Alert}>
          Supprimer mon compte
        </Button>
      </div>
      <DeleteAccountModal isOpen={isDeleteModalOpen} setOpen={setDeleteModalOpen} />
    </ProfileLayout>
  );
};
